module.exports = __webpack_public_path__ + "static/async_diagram-033ca80cddb7f5f9848363326fb8e093.png";